import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../constants';
import { FormGenerator } from '../../helper/FormGenerator';
import { useTokens } from '../../context/TokenContext';
import { xorEncrypt } from '../../utils/xorCrypto';

const ChangePassword = ({ id }) => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
  const [loading, setLoading] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [isPasswordMatch, setIsPasswordMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    password: '',
  });


  // Handle input changes and update state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const toastId = toast.loading('Saving password...', { autoClose: false });

    try {
      const dataToSend = {
        password: xorEncrypt(formData.password),
      };

      const response = await axios.put(`${API_URL}/admin/user/${id}/change-password`, dataToSend, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${adminAuthToken}`,
        },
      });

      if (response.status === 200) {
        toast.update(toastId, {
          render: 'Password Changed successfully!',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
      }
      setFormData({
        ...formData,
        password: '',
        passwordConfirm: ''
      });
      setLoading(false);
    } catch (error) {
      toast.update(toastId, {
        render: error?.response?.data?.message || 'Failed to change password. Please try again.',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setFormData({ ...formData, password });
    const passwordRegex = /^.{8,}$/;
    setIsPasswordValid(passwordRegex.test(password));
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPassword = e.target.value;
    setFormData({ ...formData, passwordConfirm: confirmPassword });
    setIsPasswordMatch(confirmPassword === formData.password);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <h2 className='pb-1'>Change User Password</h2>
      <p className='pb-3 small fst-italic'>Change user password below.</p>

      {/* Bootstrap Form */}
      <form onSubmit={handleFormSubmit}>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password <span className="text-danger">*</span>
          </label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className={`form-control w-100 ${!isPasswordValid ? "is-invalid" : ""}`}
              id="password"
              name="password"
              value={formData.password}
              onChange={handlePasswordChange}
              required
              placeholder="Enter Password"
            />
            <span
              className="input-group-text position-absolute end-0"
              style={{ zIndex: 9, cursor: "pointer" }}
              onClick={togglePasswordVisibility}
            >
              <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
            </span>
          </div>
          {!isPasswordValid && (
            <div className="invalid-feedback">
              Password must be at least 8 characters long and contain both letters and numbers.
            </div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="confirm_password" className="form-label">
            Confirm Password <span className="text-danger">*</span>
          </label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className={`form-control w-100 ${!isPasswordMatch ? "is-invalid" : ""}`}
              id="confirm_password"
              name="confirm_password"
              value={formData.passwordConfirm}
              onChange={handleConfirmPasswordChange}
              required
              placeholder="Confirm Password"
            />
          </div>
          {!isPasswordMatch && (
            <div className="invalid-feedback">
              Passwords do not match.
            </div>
          )}
        </div>

        {/* Save Settings Button */}
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
